<template>
  <v-text-field
    class="v-currency-field"
    v-model="funding"
    :dense="dense"
    :label="placeholder"
    prefix="£"
    :rules="rules"
    required="required"
  ></v-text-field>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'v-currency-field',
  props: [
    'value',
    'answerSet',
    'customerId',
    'singleLine',
    'placeholder',
    'question',
    'page',
    'box',
    'dense',
    'required',
    'rules'
  ],
  data: () => ({
    answers: null
  }),
  computed: {
    ...mapGetters(['GetAnswersForQuestion']),
    AnswerSetId() {
      return this.answerSet.id;
    },
    funding: {
      get() {
        if (this.question.number === 1) {
          return this.format(this.value);
        } else {
          return this.answerSet ? this.format(this.answerSet.answer.answer_text) : null;
        }
      },
      set: _.debounce(function(value) {
        if (_.isObject(this.question)) {
          value = parseInt(value.replace(/[^\d.]/g, ''));
          if (isNaN(value)) {
            value = 0;
          }
          if (this.question.number === 1 && value !== this.originalValue && !_.isUndefined(this.customerId)) {
            this.$store.dispatch('updateCustomer', {
              id: this.customerId,
              updates: {
                funding: value
              }
            });
          }

          let answerId = null;
          if (!_.isNaN(value)) {
            let answers = _.orderBy(
              _.filter(this.question.answers, answer => answer.enabled === true),
              'value',
              'asc'
            );
            answerId = _.reduceRight(
              answers,
              (answerId, answer) => {
                return answer.value >= value ? answer.id : answerId;
              },
              _.last(answers).id
            );
          }

          if (!_.isUndefined(this.customerId)) {
            this.updateAnswerSet({
              id: this.customerId,
              answerSet: this.answerSet,
              answerId,
              answerText: value,
              questionId: this.question.id,
              isCritical: this.question.is_critical
            });
          }
          value = this.$emit('input', answerId, value);
        } else {
          this.$emit('input', value);
        }
      }, 750)
    },
    originalValue: {
      get() {
        return parseInt(this.value);
      }
    }
  },
  methods: {
    ...mapActions(['updateAnswerSet']),
    format(value) {
      const intValue = typeof value === 'string' ? parseInt(value.replace(/[^\d.]/g, '')) : value;

      return intValue > 0
        ? intValue.toLocaleString({
            style: 'currency',
            currency: 'GBP',
            currencyDisplay: 'symbol',
            minimumSignificantDigits: 0,
            maximumSignificantDigits: 0
          })
        : value;
    }
  },
  mounted() {
    this.answers = this.question.answers;
    if (this.value > 0) {
      this.funding = `${this.value}`;
    }
  }
};
</script>

<style lang="scss">
.v-application--is-ltr .v-text-field__prefix {
  font-size: 16px;
}

.v-text-field.v-currency-field.v-input--dense:not(.v-text-field--outlined):not(.v-text-field--single-line) {
  input {
    padding-bottom: 4px;
  }
  .v-label {
    top: 5px;
  }
}
</style>
